import React, { useRef } from 'react';
import __, { __route } from 'localisation';
import ListButton from '../ListButton';
import Heading from 'components/Heading';

const UnfinishedPersonnel = ({ signatories, beneficialOwners, user }) => {

  const unfinishedPersonnl:any = useRef([]);

  const filteredSignatories = signatories.filter((signatory) => {
    const hasSigned = signatory.powers_of_attorney.some((powerOfAttorney) => (
      powerOfAttorney.user_id === user.id && powerOfAttorney.signed_at
    ));
    return !hasSigned;
  });

  const filteredBeneficialOwners = beneficialOwners.filter(beneficialOwner => {
    const roleProvided = beneficialOwner.powers_of_attorney.some((powerOfAttorney) => (
      powerOfAttorney.user_id === user.id && powerOfAttorney.signed_at
    ));
    return !roleProvided;
  });

  unfinishedPersonnl.current = [...filteredSignatories, ...filteredBeneficialOwners];

  return (
    <>
      {(unfinishedPersonnl.current && unfinishedPersonnl.current.length > 0) && (
        <>
          <Heading size="4" className="s-bottom-m">{__('personnel_registration')}</Heading>
          <div className='flex'>
            {unfinishedPersonnl.current.map((item: any) => (
              <ListButton
                key={item.id}
                icon="Common File Text by Streamlinehq"
                href={`${__route("personnel_summary")}/${item.uuid}`}
                title={item.name}
                text={`Organisationsnummer: ${item.national_identity_number}`}
              />
            ))}
          </div>
        </>
      )}
    </>
  );

};

export default UnfinishedPersonnel;
